import * as actionTypes from "../actions/actionTypes";
import {
    clearUpdateRecordError,
    updateRecordFail,
    updateRecordStart,
    updateRecordSuccess,
    clearUpdateRecordLoading,
    cancelUpdateRecord,
    cancelAddRecord,
    addRecordStart,
    addRecordSuccess,
    addRecordFail,
    clearAddRecordError,
    clearAddRecordLoading,
    fetchRecordStart,
    fetchRecordSuccess,
    fetchRecordFail,
    clearRecord,
    addRecordToBottom,
    updateRecord,
    removeRecord,
    updateSingleRecord,
    fetchListStart,
    fetchListSuccess,
    fetchListFail,
    clearList,
    clearAllLists,
    addToBottomOfLists,
    updateInLists,
    removeFromLists,
} from "../utility";

const initialState = {
    lists: {},
    record: null,
    isRecordLoading: false,
    isRecordAddLoading: null,
    isRecordUpdateLoading: null,
    recordError: null,
    addRecordError: null,
    updateRecordError: null,
    addRecordId: null,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.FETCH_INVOICE_LIST_START: return fetchListStart(state, action.payload);
        case actionTypes.FETCH_INVOICE_LIST_SUCCESS: return fetchListSuccess(state, action.payload);
        case actionTypes.FETCH_INVOICE_LIST_FAIL: return fetchListFail(state, action.payload);
        case actionTypes.CLEAR_INVOICE_LIST: return clearList(state, action.payload);
        case actionTypes.CLEAR_INVOICE_LISTS: return clearAllLists(state);
        case actionTypes.ADD_TO_INVOICE_LIST: return addToBottomOfLists(state, action.payload);
        case actionTypes.UPDATE_IN_INVOICE_LIST: return updateInLists(state, action.payload);
        case actionTypes.REMOVE_FROM_INVOICE_LIST: return removeFromLists(state, action.payload);
        case actionTypes.FETCH_INVOICE_START: return fetchRecordStart(state);
        case actionTypes.FETCH_INVOICE_SUCCESS: return fetchRecordSuccess(state, action.payload);
        case actionTypes.FETCH_INVOICE_FAIL: return fetchRecordFail(state, action.payload);
        case actionTypes.CLEAR_INVOICE: return clearRecord(state);
        case actionTypes.ADD_INVOICE: return addRecordToBottom(state, action.payload);
        case actionTypes.ADD_INVOICE_START: return addRecordStart(state);
        case actionTypes.ADD_INVOICE_SUCCESS: return addRecordSuccess(state);
        case actionTypes.ADD_INVOICE_FAIL: return addRecordFail(state, action.payload);
        case actionTypes.ADD_INVOICE_LOADING_CLEAR: return clearAddRecordLoading(state);
        case actionTypes.ADD_INVOICE_ERROR_CLEAR: return clearAddRecordError(state);
        case actionTypes.UPDATE_INVOICE: return updateRecord(state, action.payload);
        case actionTypes.UPDATE_SINGLE_INVOICE: return updateSingleRecord(state, action.payload);
        case actionTypes.UPDATE_INVOICE_START: return updateRecordStart(state);
        case actionTypes.UPDATE_INVOICE_SUCCESS: return updateRecordSuccess(state);
        case actionTypes.UPDATE_INVOICE_FAIL: return updateRecordFail(state, action.payload);
        case actionTypes.UPDATE_INVOICE_LOADING_CLEAR: return clearUpdateRecordLoading(state);
        case actionTypes.UPDATE_INVOICE_ERROR_CLEAR: return clearUpdateRecordError(state);
        case actionTypes.ADD_INVOICE_CANCEL: return cancelAddRecord(state);
        case actionTypes.UPDATE_INVOICE_CANCEL: return cancelUpdateRecord(state);
        case actionTypes.REMOVE_INVOICE: return removeRecord(state, action.payload);
        default:
            return state;
    }
};

export default reducer;